import { styled } from '../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
`;

export const LogoSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5e5;
    flex-shrink: 0;
`;

export const LogoImage = styled.img`
    max-height: 52px;
    max-width: 200px;
    object-fit: contain;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    padding: 40px 32px 0;
    gap: 20px;
    text-align: center;
`;

export const CheckCircle = styled.div<{ $color: string }>`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 3.5px solid ${({ $color }) => $color};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 24px;
    font-weight: 500;
    color: ${({ $color }) => $color};
    margin: 0;
    line-height: 1.3;
`;

export const Subtitle = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #555;
    margin: 0;
    line-height: 1.6;
`;

export const CountsCard = styled.div<{ $color: string }>`
    width: 100%;
    box-sizing: border-box;
    border-radius: 14px;
    border: 1.5px solid ${({ $color }) => $color}44;
    background: linear-gradient(160deg, ${({ $color }) => $color}1f, #ffffff 80%);
    padding: 16px 18px;
    display: flex;
    flex-direction: row;
    gap: 0;
`;

export const CountCell = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
`;

export const CountDivider = styled.div`
    width: 1px;
    background-color: #e5e5e5;
    flex-shrink: 0;
    margin: 4px 0;
`;

export const CountLabel = styled.span`
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #718096;
`;

export const CountValue = styled.span<{ $color: string }>`
    font-size: 26px;
    font-weight: 800;
    color: ${({ $color }) => $color};
    line-height: 1.1;
`;

export const Separator = styled.div`
    width: calc(100% - 64px);
    height: 1px;
    background-color: #e5e5e5;
    margin-top: 32px;
    flex-shrink: 0;
`;

export const Footer = styled.footer`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 24px;
    margin-top: auto;
`;
